<template>
  <div class="quill-editor" :class="disabled ? 'disabled' : ''">
    <slot name="toolbar"></slot>
    <div ref="editor"></div>
  </div>
</template>

<script>
  import {abstractField} from "vue-form-generator";
  import Quill from 'quill'
  import Delta from 'quill-delta'
  import {imageUrl} from '@/helpers/components/display/ItemImage'
  import ImageBrowser from '@/helpers/components/interact/ImageBrowser'
  import ModalDialogs from 'vue-modal-dialogs'
  // Make a dialog function
  const selectfromgallery = ModalDialogs.makeDialog(ImageBrowser, 'current', 'sizeselect')

  export default {
    name: 'field-html',
    mixins: [abstractField],
    data () {return {
      quillOptions: {
        theme: 'snow',
        boundary: document.body,
        modules: {toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            //[{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            //[{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video']
          ],
          handlers: {
            image: function (value) {
              selectfromgallery(false, true).then((image) => {
                if (image) {
                  let size = image.hasOwnProperty('size') ? image.size : 'original';
                  let range = this.quill.getSelection(true);
                  this.quill.updateContents(new Delta()
                    .retain(range.index)
                    .delete(range.length)
                    .insert({ image: imageUrl(image, size) })
                  , "user");
                  this.quill.setSelection(range.index + 1, "silent");
                }
              });
            },
          }
        }},
      },
      _quillvalue: '',
    }},
    mounted () {
      this.initialize()
    },
    beforeDestroy () {
      this.quill = null
      delete this.quill
    },
    methods: {
      // Init Quill instance
      initialize () {
        if (!this.$el) {
          return;
        }
        // Instance
        this.quill = new Quill(this.$refs.editor, this.quillOptions);
        // Set editor content
        if (this.value) {
          this.quill.pasteHTML(this.value);
        }
        // Disabled editor
        if (this.disabled) {
          this.quill.enable(false);
        }

        // Mark model as touched if editor lost focus
        this.quill.on('selection-change', range => {
          if (!range) {
            this.$emit('blur', this.quill)
          } else {
            this.$emit('focus', this.quill)
          }
        })

        // Update model if text changes
        this.quill.on('text-change', () => {
          let html = this.$refs.editor.children[0].innerHTML;
          const quill = this.quill;
          const text = this.quill.getText();
          if (html === '<p><br></p>') html = '';
          this._quillvalue = html;
          this.value = html;
        });

        // Emit ready event
        this.$emit('ready', this.quill);
      }
    },
    watch: {
      // Watch content change
      value(newVal, oldVal) {
        if (this.quill) {
          if (newVal && newVal !== this._quillvalue) {
            this.quill.pasteHTML(newVal);
          } else if (!newVal) {
            this.quill.setText('')
          }
        }
      },
      // Watch disabled change
      disabled (newVal, oldVal) {
        if (this.quill) {
          this.quill.enable(!newVal)
        }
      }
    }
  }
</script>

<style lang="scss">
  @import 'quill/dist/quill.core.css';
  @import 'quill/dist/quill.snow.css';


.quill-editor {
  .ql-toolbar.ql-snow,
  .ql-container.ql-snow {
    border-width: 2px;
  }
  .ql-container.ql-snow {
    height: 300px;
    @include font-size(16px);
  }
  &.disabled {
    opacity: .6;
  }
}
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/form/HtmlEditor.vue